import { render, staticRenderFns } from "./StudentEditInfoSlidebar.vue?vue&type=template&id=5a37d92a"
import script from "./StudentEditInfoSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentEditInfoSlidebar.vue?vue&type=script&lang=js"
import style0 from "./StudentEditInfoSlidebar.vue?vue&type=style&index=0&id=5a37d92a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports